// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fontdiner+Swanky&family=Kaushan+Script&family=Keania+One&family=Protest+Revolution&family=Uncial+Antiqua&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sVsLpNI4ZYCYSptLlkew {
  height: 100%;
  width: 100%;
  background-image: url("https://i.imgur.com/FR20g2h.jpeg");
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.sVsLpNI4ZYCYSptLlkew .IUKGw2P8GkubIrMoEJp7 {
  color: red;
  font-size: 10vmin;
  font-family: "Protest Revolution", sans-serif;
  text-shadow: 2px 2px 2px black;
}`, "",{"version":3,"sources":["webpack://./src/components/HorrorIndex/HorrorIndex.module.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AAAJ;AACI;EACI,UAAA;EACA,iBAAA;EACA,6CAAA;EACA,8BAAA;AACR","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Fontdiner+Swanky&family=Kaushan+Script&family=Keania+One&family=Protest+Revolution&family=Uncial+Antiqua&display=swap');\n\n.horrorIndex {\n    height: 100%;\n    width: 100%;\n    background-image: url('https://i.imgur.com/FR20g2h.jpeg');\n    background-size: cover;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    .title {\n        color: red;\n        font-size: 10vmin;\n        font-family: \"Protest Revolution\", sans-serif;\n        text-shadow: 2px 2px 2px black;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"horrorIndex": `sVsLpNI4ZYCYSptLlkew`,
	"title": `IUKGw2P8GkubIrMoEJp7`
};
export default ___CSS_LOADER_EXPORT___;
